module.exports = __webpack_public_path__ + "static/media/medicated-magic-banner.ffc5b28e.png";